var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-modal-wrapper"},[_c('q-btn',{staticClass:"absolute btn-create-resource",attrs:{"fab":"","color":"positive","icon":"add"},on:{"click":_vm.open}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }